export default "__VITE_ASSET__BiEhz4jV__"